import React from 'react';

function Card(props) {
    const cardwidth = "col-lg-" + props.cardwidth

    return(
        <div className={cardwidth}>
            <div className="card">
                <div className="is-shadowless card-header">
                    <div className="card-title h6">
                        <h4 className="font-weight-bold text-black">{props.title}</h4>
                        <small className="text-black">{props.subtitle} </small>
                    </div>
                </div>
                {props.child}
                {props.legend}
            </div>
        </div>
    );
}

export default Card;